<div>
  <LoginButton :isAuthenticated="isAuthenticated" @update:isAuthenticated="isAuthenticated = $event"
    @auth-changed="handleAuthChange" />

  <InfiniteMode :showButton="showInfiniteMode" @enable-infinite-mode="enableInfiniteMode" />

  <Header />

  <p id="nb_diario" v-if="dataLoaded"
    style="text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center;">
    <span>{{getUsername}}</span>
    <span>Puzzle diario #{{puzzle_nb}}</span>
  </p>

  <!-- The Rules Popup -->
  <Rules />

  <Grid v-if="dataLoaded" ref="grid" :gridData="guessGrid" :isDisabled="has_lost" @cell-input="onCellInput" />



  <!-- Lives, Win and Lose messages -->
  <div v-if="dataLoaded">
    <LivesDisplay :lives="lives" :totalLives="selectedSize" :hasLost="has_lost" :infiniteMode="infiniteMode" />

    <WinMessage :isSolved="isSolved" />

    <LostMessage :hasLost="has_lost" :buttonText="messageLostButton" @toggle-solution="setLoserGrid" />

    <ranking-popup ref="rankingPopup" :puzzle_nb="puzzle_nb" :finished_playing="finished_playing" />

  </div>

  <!-- Definitions -->
  <Definitions v-if="dataLoaded" :definitionsHtml="displayHtml" />

  <!-- Pistas -->
  <Hints :selectedSize="selectedSize" :hasdef2="hasdef2" :def2Empty="def2_empty" :hasLost="has_lost"
    :size="selectedSize" :hint1_is_disabled="hint1_is_disabled" :hint2_is_disabled="hint2_is_disabled"
    :hint3_is_disabled="hint3_is_disabled" @show-letter-type="showLetterType" @show-def-bis="showDefBis"
    @show-letter="showLetter" @toggle-rules="toggleRules" />

  <!-- Help button -->
  <Rules :rulesAreVisible="rulesAreVisible" @toggle-rules="toggleRules" />

</div>
